import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LogService } from '@logs/services/log.service';
import { Observable } from 'rxjs';
import { ServerInfoResponse } from './../models/server-info.model';
import { URLS } from '@tool/tool.config';

const SERVICE_NAME = 'ServerInfoService';

@Injectable()
export class ServerInfoService {
  private http: HttpClient = inject(HttpClient);
  private logService: LogService = inject(LogService);

  public getServerInfo(): Observable<ServerInfoResponse> {
    this.logService.logInfo(`[${SERVICE_NAME}] Retrieving server version information`);
    return this.http.get<ServerInfoResponse>(URLS.GET_SERVER_INFO, { withCredentials: false });
  }
}
